export const getSortOptionsState = (numOfSlices, sortOptions) => {
  const selectedSortOption = sortOptions.find((option) => option.isSelected)?.value || 'LOWEST_PRICE'
  return new Array(numOfSlices)
    .fill(selectedSortOption)
    .reduce((state, el, index) => ({ ...state, [index + 1]: el }), {})
}
